import CheckCircleTwoTone from '@ant-design/icons/CheckCircleTwoTone'
import DownOutlined from '@ant-design/icons/DownOutlined'
import StopTwoTone from '@ant-design/icons/StopTwoTone'
import { Tooltip } from 'antd'
import React, { FC, ReactNode } from 'react'
import styled from 'styled-components'
import { GeckoTheme } from 'styles/GeckoTheme'

const FinalResultIconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

interface ResultIconProps {
  passed: boolean
  tooltipFailureText?: string
  trailingPass?: ReactNode
  trailingFail?: ReactNode
}

const ICON_STYLE: React.CSSProperties = {
  fontSize: '36px',
}

export const DownwardIndicator: ReactNode = (
  <DownOutlined
    style={{
      ...ICON_STYLE,
      color: GeckoTheme.colors.grayscale[400],
    }}
  />
)

export const RawFfsResultIcon: FC<ResultIconProps> = ({
  passed,
  tooltipFailureText,
  trailingFail,
  trailingPass,
}) => {
  return (
    <FinalResultIconContainer>
      {passed ? (
        <>
          <CheckCircleTwoTone style={ICON_STYLE} twoToneColor={'green'} />
          {trailingPass}
        </>
      ) : (
        <>
          <Tooltip title={tooltipFailureText}>
            <StopTwoTone style={ICON_STYLE} twoToneColor={'red'} />
          </Tooltip>
          {trailingFail}
        </>
      )}
    </FinalResultIconContainer>
  )
}

export const FfsResultIcon = React.memo(RawFfsResultIcon)
